<template>
  <div>
    <a-modal
      title="新增返利群组"
      :width="600"
      :visible="visible"
      :confirmLoading="confirmLoading"
      @cancel="handleCancel"
    >
      <a-spin :spinning="confirmLoading">
        <a-alert message="如果找不到您要选择的分组，请到所有群组刷新后，再进行添加" :style="{marginBottom: '10px'}"></a-alert>
        <a-form :form="form">
          <a-form-item
            label="群组微信ID"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol">
            <a-input
              v-decorator="['wxid', { rules: [{required: true, message: '必填项'}]}]"
              placeholder="必填项"
            />
            <a
              class="select-btn"
              @click="$refs.selectGroupModal.show({robotid:currentRobotId})"
            >选择群组</a>
          </a-form-item>
          <a-form-item label="群组名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['nickname']" placeholder="选填" />
          </a-form-item>
          <a-form-item label="群主UID" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['masteruid']" placeholder="选填" />
            <a class="select-btn" @click="handleSelectGroupUser">选择群主</a>
          </a-form-item>
          <a-form-item label="群主微信ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['masterwxid']" placeholder="选填" />
          </a-form-item>
          <a-form-item label="群主微信昵称" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['mastername']" placeholder="选填" />
          </a-form-item>
          <a-form-item label="佣金比例" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number
              :style="{width:'100%'}"
              v-decorator="['tkcommission']"
              :min="0"
              :max="100"
              :step="0.01"
              placeholder="选填"
              :formatter="value => `${value}%`"
              :parser="value => value.replace('%', '')"
            />
          </a-form-item>
          <a-form-item label="备注信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['remark']" placeholder="选填" />
          </a-form-item>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button @click="handleCancel">取消</a-button>
        <a-button :loading="confirmLoading" type="primary" @click="handleSubmit">确定</a-button>
      </template>
    </a-modal>
    <select-group-modal ref="selectGroupModal" @change="onChangeGroup"></select-group-modal>
    <select-group-user-modal ref="selectGroupUserModal" @change="onChangeGroupUser"></select-group-user-modal>
  </div>
</template>

<script>
import GroupApi from '@/api/group'
import SelectGroupModal from '@/views/components/SelectGroupModal'
import SelectGroupUserModal from './SelectGroupUserModal'
export default {
  components: {
    SelectGroupModal,
    SelectGroupUserModal
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      visible: false,
      confirmLoading: false,
      currentRobotId: null,
      form: this.$form.createForm(this)
    }
  },
  methods: {
    show(robot_id) {
      this.currentRobotId = robot_id
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          let params = values
          params.sub_id = this.currentRobotId
          GroupApi.saveApplyGroup(params)
            .then(res => {
              if (res.code === 1) {
                this.form.resetFields()
                this.$message.success('新增成功')
                this.visible = false
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    onChangeGroup(data) {
      this.form.setFieldsValue({
        wxid: data.group_wx_id,
        nickname: data.group_nickname
      })
      this.$refs.selectGroupModal.handleCancel()
    },
    onChangeGroupUser(data) {
      const id = data.id
      const wx_id = data.wx_id
      const avatar = data.avatar
      const nickname = data.nickname
      this.confirmLoading = true
      GroupApi.getGroupUserInfo({
        sub_id: this.currentRobotId,
        wx_id: wx_id,
        nickname: nickname,
        avatar: avatar
      })
        .then(res => {
          if (res.code === 1) {
            this.form.setFieldsValue({
              masteruid: res.data.uid,
              masterwxid: wx_id,
              mastername: nickname
            })
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.confirmLoading = false
        })

      this.$refs.selectGroupUserModal.handleCancel()
    },
    handleSelectGroupUser() {
      const robot_id = this.currentRobotId
      const group_wx_id = this.form.getFieldValue('wxid')
      if (!group_wx_id) {
        this.$message.error('请选填写微信群组ID')
        return false
      }
      this.$refs.selectGroupUserModal.show(robot_id, group_wx_id)
    }
  }
}
</script>
<style lang="less" scoped>
.select-btn {
  position: absolute;
  top: 100%;
  right: 0;
  line-height: 35px;
}
</style>

